import { CLIENT_BY_ID, CLIENT_BY_ID_PROGRESS } from '../actions/getClientByIdAction'
     
export default (state={ },action)=>{
    
    switch(action.type){
        case CLIENT_BY_ID_PROGRESS:
                return false;
    case CLIENT_BY_ID:
        return action.data
    default:
    return state;
    }
}